import type { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";

type ProjectedCoverages = Record<string, unknown> | null | undefined;

/**
 * Form path of a unit-level coverage field (extra key like `sinkhole`, or NBS
 * base key like `coverageA_value`); all of them live on the first unit.
 */
export const getUnitCoverageFormPath = (key: string) =>
  `units.0.unitLevelCoverages.${key}`;

const isHidden = (coverage: unknown) =>
  (coverage as { valueIsHidden?: boolean } | null | undefined)
    ?.valueIsHidden === true;

/** Drops the form values of the coverages a save response hides. */
export const clearHiddenExtraCoverages = <T extends FieldValues>(
  form: Pick<UseFormReturn<T>, "unregister">,
  {
    unitLevelCoverages,
    policyLevelCoverages,
  }: {
    unitLevelCoverages?: ProjectedCoverages;
    policyLevelCoverages?: ProjectedCoverages;
  }
) => {
  const paths = [unitLevelCoverages, policyLevelCoverages].flatMap(
    (coverages) =>
      Object.entries(coverages ?? {})
        .filter(([, coverage]) => isHidden(coverage))
        .map(([key]) => getUnitCoverageFormPath(key) as FieldPath<T>)
  );

  if (paths.length > 0) form.unregister(paths);
};
